import * as Sentry from '@sentry/react';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { locales } from '../config/locales';
import { ProviderPlugins } from '../config/providers';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {},
    fallbackLng: 'en',
    debug: import.meta.env.DEV,
    keySeparator: false,
    // Supported languages
    supportedLngs: locales,
    // Language detection configuration
    detection: {
      // Order of detection: localStorage first, then browser language
      order: ['localStorage', 'navigator'],
      // Cache user language on localStorage
      caches: ['localStorage'],
      // Key to store language preference in localStorage
      lookupLocalStorage: 'i18nextLng',
    },
  });

i18n.on('languageChanged', (language) => {
  document.documentElement.lang = language;
});

/** Load all translations before rendering the authentication screens. */
export async function registerTrads() {
  // Register common trads
  await Promise.all(
    locales.map(async (locale) => {
      try {
        const data: { default: object } = await import(`../translations/${locale}.json`);
        i18n.addResourceBundle(locale, 'translation', data.default);
      } catch (error) {
        console.error(error);
        Sentry.captureException(error);
        console.warn(`Missing common "${locale}" locale file.`);
      }
    }),
  );

  // Register providers trads
  await Promise.all(
    Object.entries(ProviderPlugins).map(([provider, plugin]) =>
      plugin.registerTrads({ locales, i18n }).catch(() => console.warn(`Missing one of "${provider}" locale file.`)),
    ),
  );

  // Resolve the detected language now that its resource bundles are available.
  await i18n.changeLanguage(i18n.language);
}

export default i18n;
